import React from 'react';
import styles from './OnMapInfoWindow.module.scss'
import {ReactComponent as PinIcon} from "../../../assets/images/svg/PinBlack.svg";
import {ReactComponent as MusicIcon} from "../../../assets/images/svg/MusicIcon.svg";
import {useNavigate} from "react-router-dom";

const OnMapInfoWindowComponent = (props: {id?: any,  address: string, options: any[], handleBook: any}) => {
    const navigation = useNavigate()
    return (
        <div className={`${styles.container} col `}>
            <div className={'row align-items-center mb-20'}>
                <PinIcon className={'mr-15'} />
                <span className={'text-black main-text'}>{props.address}</span>
            </div>
            <div className={'row align-items-center'}>
                <MusicIcon  className={'mr-15'} />
                <span className={'text-black main-text'}>{props.options.join(', ')}</span>
            </div>
            <div style={{width: '100%'}} className={'mt-30 row justify-content-center'}>
                <div className={'red-button row center-content pointer'} style={{width: 154}} onClick={()=>navigation(`/building/${props.id}`)}>
                    <span className={'red-button-text'}>Book</span>
                </div>
            </div>

        </div>
    );
};

export default OnMapInfoWindowComponent;
export {};
